module.exports = __webpack_public_path__ + "img/page41.bcc23a9b.gif";